import React, { memo } from 'react'

import ArtworkItem from '@modules/Catalog/Artworks/ArtworkItem'
import { Carousel, Row, Col, Container } from '@mch-group/uikit-components'
import { useModuleContext } from '../contexts/module'
import useGetArtworksRecommendations from '../hooks/useGetArtworksRecommendations'

/**
 * Shows a specified number of artworks related to the artworkId specified
 * @returns {JSX.Element}
 * @constructor
 */
const Recommendations = () => {
  const { state: { artworkInformation, labels } } = useModuleContext()
  const {
    onlineShowId,
    id,
    artistId,
    showRecommendationAlgorithms,
    artist
  } = artworkInformation || {}
  const { data: artworks, isLoading } =
    useGetArtworksRecommendations(id, artistId, onlineShowId, showRecommendationAlgorithms)

  const placeholders = React.useRef(
    [...Array(4).keys()].map((i) => ({ id: i * -1, heightFactor: Math.random() * 0.6 + 0.5 }))
  )
  const isMlLogic = showRecommendationAlgorithms === 'REC_ENG_ALG'
  const title = isMlLogic ? labels?.OnlineShowRoom?.recommendedArtworksLabel : `${labels?.OnlineShowRoom?.recommendationsSectionHeading} ${artist}`
  const artworksItems = isLoading && !artworks?.items?.length ? placeholders.current : artworks.items
  if (!isLoading && artworksItems.length > 0) {
    return (
      <Container className='bg-white position-relative z-1 px-5 px-lg-8 px-md-7 mt-7'>
        <Row>
          <Carousel
            exceedTrack
            //@ts-ignore
            title={title}
            showTopBorders={false}
            showBottomBorders={false}
          >
            {artworksItems.map((item) => (
              <Carousel.Slide key={item.id}>
                <Col className='mb-lg-3 mb-md-3'>
                  <ArtworkItem
                    imageType='contained'
                    pageType='listing'
                    isHideCuratorName
                    {...item}
                    showViewAtFair
                    recommendedArtwork
                  />
                </Col>
              </Carousel.Slide>))}
          </Carousel>
        </Row>
      </Container>
    )
  } else {
    return (<div className='mb-15' />)
  }
}

export default memo(Recommendations)
